"use client";

import { useEffect, useState } from "react";

import {
  ClientSearchExisting,
  ClientSearchItem,
} from "@/components/backoffice/cat/client/client-search-existing";
import { ClientInfoLayout } from "@/components/backoffice/cat/client/client-info-layout";

function AvsClientStep({
  onCanProceedChange,
}: {
  onCanProceedChange?: (canProceed: boolean) => void;
}) {
  const [selectedClientId, setSelectedClientId] = useState<string | null>(null);

  useEffect(() => {
    onCanProceedChange?.(selectedClientId !== null);
  }, [onCanProceedChange, selectedClientId]);

  return (
    <ClientInfoLayout>
      <ClientSearchExisting
        selectedClientId={selectedClientId}
        onSelect={(client: ClientSearchItem) => setSelectedClientId(client.id)}
      />
    </ClientInfoLayout>
  );
}

export { AvsClientStep };
